import { Avatar, Box, Button, Divider, Grid, Stack, Typography } from '@mui/material';
import React, { useContext } from 'react';
import snooze from './Components/SnoozeGif.gif';
import { LanguageContext } from '../../../libs/Context';

const RemindCard = () =>
{
	const { language } = useContext(LanguageContext);

	return (
		<Grid container sx={{ background: 'linear-gradient(180deg, #FFE6E2 0%, #FFFFFF 100%)', border: '1px solid #DED8D8', borderRadius: '13px' }} direction={'column'} p='var(--pixel16)'>
			<Grid item xs={12} display={'flex'} justifyContent={'center'} alignItems={'center'} >
				<Box component={'img'} src={snooze} height={'54px'} width={'54px'} sx={{ mixBlendMode: 'multiply' }} />
			</Grid>
			<Grid item display={'flex'} justifyContent={'center'} alignItems={'center'} gap={2} my='var(--pixel16)'>
				<Avatar src='https://www.nme.com/wp-content/uploads/2023/07/J-Robert-Oppenheimer-new.jpg' sx={{ height: '38px', width: '38px' }}/>
				<Stack direction={'column'}>
					<Stack direction={'row'} spacing={2}>
						<Typography fontSize='var(--pixel12)' fontWeight='var(--font500)' color={'#64748B'}>12:30 PM</Typography>
						<Typography fontSize='var(--pixel12)' fontWeight='var(--font400)' color={'#64748B'}>Mon, Sep 30, 2024</Typography>
					</Stack>
					<Typography fontSize='var(--pixel16)' fontWeight='var(--font600)' color={'#283C50'}>UI/UX Sprint Demo</Typography>
				</Stack>
			</Grid>
			<Grid item xs={12} display={'flex'} justifyContent={'center'} alignItems={'center'}>
				<Typography fontSize='var(--pixel12)' fontWeight='var(--font600)'>
					Before going to demo need to verify the build
				</Typography>
			</Grid>
			<Grid item xs={12}>
				<Divider orientation='horizontal' flexItem sx={{ my: 2, border: '1px solid #979797' }} />
			</Grid>
			<Grid item display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
				<Button sx={{ width: 'var(--font120)', borderRadius: 'var(--pixel4)' }}>{language?.dismiss}</Button>
				<Button variant='contained' sx={{ color: 'var(--whiteColor)', borderRadius: 'var(--pixel4)', boxShadow: 'none ', textTransform: 'inherit !important' }}>{language?.snoozeFor} 5 minutes</Button>
			</Grid>
		</Grid>
	);
};

export default RemindCard;
